import { i18nextT } from "../../../hooks/i18n/i18n";
import type { HostingStyleMap } from "utility/hosting";
import favicon from "designs/images/external/virtuacul/favicon.png";
import logo from "designs/images/external/virtuacul/logo.png";

export const baseStyles = (): HostingStyleMap => {
  return {
    baseStyles: {
      baseColor: "#8DFFE9",
      mainColor: "#FFFFFF",
      accentColor: "#8B36FF",
      fontPrimaryColor: "#000",
      fontSecondaryColor: "#000",
      backgroundImage: null,
    },

    commonSettings: {
      auth: {
        loginMethod: {
          twitter: true,
          facebook: false,
        },
      },
      route: {
        home: "/events",
      },
      meta: {
        favicon,
        appleTouchIcon: favicon,
        title: i18nextT("hosting.templates.virtuacul-1.common.meta.title"),
        description: null,
        copyright: i18nextT("hosting.templates.virtuacul-1.footer.copyright"),
      },
      header: {
        logo: {
          isDisplay: true,
          path: logo,
        },
        textColor: "#000",
        svgColor: "#000",
      },
      menu: {
        home: {
          isDisplay: false,
        },
        event: {
          isDisplay: true,
          text: i18nextT(
            "hosting.templates.virtuacul-1.common.section.event.name"
          ),
        },
        archive: {
          isDisplay: false,
          text: i18nextT(
            "hosting.templates.virtuacul-1.common.section.archive.name"
          ),
        },
        account: {
          isDisplay: true,
        },
        pastEvents: {
          isDisplay: false,
          text: i18nextT(
            "hosting.templates.virtuacul-1.common.section.pastEvents.name"
          ),
        },
        eventNotes: {
          isDisplay: false,
          path: null,
        },
        guide: {
          isDisplay: true,
        },
        contact: {
          isDisplay: true,
          path: null,
        },
      },
      isDisplayBreadcrumb: true,
      isDisplayEventDate: true,
      isDisplayEventTime: true,
    },

    pageSettings: {
      topPage: {
        upcomingHeadline: {
          isDisplay: false,
          mainText: null,
          subText: null,
        },
        isDisplayTodaysEvent: false,
        isDisplayInfoArea: false,
        isDisplayDeliveryDisplayArea: false,
        isDisplayCatchCopy: false,
      },
      eventListPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventDatetimeLabel: true,
        /** ------------------------- */
      },
      eventPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventState: true,
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
        linkInPage: {
          color: "#000",
          link01: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.linkInEvent.link01.text"
            ),
          },
          link02: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.linkInEvent.link02.text"
            ),
          },
          link03: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.linkInEvent.link03.text"
            ),
          },
          link04: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.linkInEvent.link04.text"
            ),
          },
          link05: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.linkInEvent.link05.text"
            ),
          },
        },
        artistInfo: {
          isDisplayArtistStateLabel: false,
          headline: {
            isDisplay: true,
            text: i18nextT(
              "hosting.templates.virtuacul-1.event.artistInfo.heading.text"
            ),
            subText: i18nextT(
              "hosting.templates.virtuacul-1.event.artistInfo.heading.subText"
            ),
          },
        },
        purchaseButton: {
          path: null,
        },
      },
      goodsPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayGoodsInfo: true,
        /** ------------------------- */
      },
      streamingPage: {
        isDisplaySuperChatArea: true,
      },
      accountTicketPage: {
        /** -- 基本的にtrueで設定する -- */
        isDisplayEventTitle: true,
        isDisplayArtist: true,
        isDisplayShareButton: true,
        /** ------------------------- */
      },
    },
  };
};
